module.exports = __webpack_public_path__ + "media/应用服务.3ab36965.mp4";